import { CSSProperties } from 'react';
import { usePlaceholderStyles } from './placeholders.styles';

export function TextPlaceholder({
  lineCount = 1,
  width,
  fullWidth,
  fontSize,
  style
}: {
  lineCount?: number;
  width?: string;
  fullWidth?: boolean;
  fontSize?: number;
  style?: CSSProperties;
}) {
  const classes = usePlaceholderStyles({ textWidth: width, textFullWidth: fullWidth, textFontSize: fontSize });
  return (
    <>
      {Array(lineCount)
        .fill('')
        .map((_, idx) => (
          <div key={idx} style={style} className={[classes.text, classes.pulse].join(' ')}></div>
        ))}
    </>
  );
}
